var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg88(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.7181 10.2901C1.64865 10.103 1.64865 9.89715 1.7181 9.71006C2.39452 8.06993 3.5427 6.66759 5.01708 5.6808C6.49146 4.69402 8.22564 4.16724 9.99977 4.16724C11.7739 4.16724 13.5081 4.69402 14.9825 5.6808C16.4568 6.66759 17.605 8.06993 18.2814 9.71006C18.3509 9.89715 18.3509 10.103 18.2814 10.2901C17.605 11.9302 16.4568 13.3325 14.9825 14.3193C13.5081 15.3061 11.7739 15.8329 9.99977 15.8329C8.22564 15.8329 6.49146 15.3061 5.01708 14.3193C3.5427 13.3325 2.39452 11.9302 1.7181 10.2901Z",
    stroke: "#0E0E0E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99977 12.5001C11.3805 12.5001 12.4998 11.3808 12.4998 10.0001C12.4998 8.61934 11.3805 7.50006 9.99977 7.50006C8.61906 7.50006 7.49977 8.61934 7.49977 10.0001C7.49977 11.3808 8.61906 12.5001 9.99977 12.5001Z",
    stroke: "#0E0E0E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg88);
export default __webpack_public_path__ + "static/media/svg88.2749ce2be86a97305b19a922f6545252.svg";
export { ForwardRef as ReactComponent };